/* Drago video lazy-load.
   The site's looping videos are large (1080p). By default some have preload="auto"
   + autoplay, so the browser downloads the FULL file on page load even for videos
   far down the page. On slow connections that stalls everything.

   This script makes every video load ONLY when it scrolls into view:
   - Neutralizes eager preload (sets preload="none") and removes the bare autoplay
     attribute so nothing downloads up front.
   - An IntersectionObserver starts the download + playback when a video is ~25%
     in view, and pauses it when it leaves view (freeing bandwidth).
   Above-the-fold videos are in view on load, so they still start right away.
*/
(function () {
  'use strict';
  function init() {
    var vids = document.querySelectorAll('video');
    if (!vids.length) return;

    vids.forEach(function (v) {
      v.dataset.dragoAutoplay = v.hasAttribute('autoplay') ? '1' : '0';
      // Stop the browser from eagerly downloading the file.
      try { v.preload = 'none'; } catch (e) {}
      // Remove the bare autoplay attribute; we drive playback via the observer so
      // off-screen videos never auto-download.
      v.removeAttribute('autoplay');
      v.muted = true;            // required for programmatic muted autoplay
      v.setAttribute('playsinline', '');
    });

    if (!('IntersectionObserver' in window)) {
      // No observer support: fall back to letting them autoplay normally.
      vids.forEach(function (v) {
        if (v.dataset.dragoAutoplay === '1') { v.preload = 'metadata'; v.setAttribute('autoplay', ''); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.preload === 'none') { v.preload = 'auto'; }
          if (v.dataset.dragoAutoplay === '1') {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        } else {
          // Pause off-screen looping videos to stop background buffering.
          if (v.dataset.dragoAutoplay === '1') { try { v.pause(); } catch (e) {} }
        }
      });
    }, { threshold: 0.25, rootMargin: '100px 0px 100px 0px' });

    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
